export default "__VITE_PUBLIC_ASSET__2f980cf9__"